import { useSelector } from "react-redux";
import { RootSliceType } from "redux/reducers/rootReducer";
import {IReservationIndividualNotUsed} from "../reducers/reservationIndividualNotUsedSlice";

const useReservationIndividualNotUsed = () => {
    const reservationIndividualNotUsed = useSelector<
        RootSliceType,
        IReservationIndividualNotUsed["reservationIndividualNotUsed"]
        >((state) => state.reservationIndividualNotUsedSlice.reservationIndividualNotUsed);

    const loading = useSelector<
        RootSliceType,
        IReservationIndividualNotUsed["loading"]
        >((state) => state.reservationIndividualNotUsedSlice.loading);

    return {
        reservationIndividualNotUsed,
        loading,
    };
};

export default useReservationIndividualNotUsed;
